// Vue
import { ref } from "vue";

// Dependencies
import { defineStore } from "pinia";

// Utils
import getLifetimeTableFromApi from "@/api/services/LifetimeTableApi";

// Types
import { LifetimeTable } from "./LifetimeTableTypes";

interface LifetimeTableProvider {
  getLifetimeTable: () => LifetimeTable | undefined;
  setLifetimeTable: (newTable: LifetimeTable) => void;
  refreshLifetimeTable: (force?: boolean) => Promise<void>;
}

const useLifetimeTable = defineStore("LifetimeTableProvider", (): LifetimeTableProvider => {
  // ///////////////////
  // Refs
  // ///////////////////

  const lifetimeTable = ref<LifetimeTable>();

  // ///////////////////
  // Getters
  // ///////////////////

  const getLifetimeTable = (): LifetimeTable | undefined => lifetimeTable.value;

  // ///////////////////
  // Setters
  // ///////////////////

  const setLifetimeTable = (newTable: LifetimeTable) => {
    lifetimeTable.value = newTable;
  };

  // ///////////////////
  // Methods
  // ///////////////////

  const refreshLifetimeTable = async (force?: boolean) => {
    if (lifetimeTable.value && !force) return;
    const newTable = await getLifetimeTableFromApi();
    setLifetimeTable(newTable);
  };

  // ///////////////////
  // Return
  // ///////////////////

  return {
    getLifetimeTable,
    setLifetimeTable,
    refreshLifetimeTable,
  };
});

export default useLifetimeTable;
